import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordSameValidator(oldPasswordControlName: string, newPasswordControlName: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const oldPassword = formGroup.get(oldPasswordControlName)?.value;
    const newPassword = formGroup.get(newPasswordControlName)?.value;
    return oldPassword === newPassword ? { passwordsMatches: true } : null;
  };
}